import { useTranslation } from "react-i18next";

// Text genèric traduït (t()) dins dels textos propis de cada pàgina.
const Tr = ({ k }) => {
    const { t } = useTranslation();
    return t(k);
};

export default Tr;
